/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   loadHomepageSpotlightListings thunk
 */

import { getInventorySearchFriendlyFilters } from '@zcode-ui/filters'
import { AnalyticsC, isCommonAuthError, trackGAEvent } from '@zcode/nr-utils'
import { maplistSpotlight } from '@zcode/nr/es/shared/api'
import Listable from '@zcode/nr/es/shared/bizos/listable'
import type { RawListable } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import { logger } from '../../../logger'
import {
  receiveSpotlightListables,
  setIsSpotlightListablesLoading,
} from '../../../modules/homepage/actions'
import { DEFAULT_SPOTLIGHT_LIMIT } from '../../main/Rail/CurrentSearchView/constants'

const loadHomepageSpotlightListings =
  (cityState: string | undefined) => async (dispatch: Dispatch) => {
    try {
      if (cityState) {
        const spotlightQuery = getInventorySearchFriendlyFilters({
          filters: { url: cityState },
          urlOnly: true,
        })

        maplistSpotlight
          .query({
            filters: { ...spotlightQuery, limit: DEFAULT_SPOTLIGHT_LIMIT },
          })
          .then(({ listables }) => {
            const spotlight = listables.map((listable: RawListable) => {
              const spotlightListable = Listable.fromJS({
                is_spotlight: true,
                ...listable,
              })

              return spotlightListable
            })

            dispatch(receiveSpotlightListables(spotlight))
          })

        trackGAEvent(AnalyticsC.HOMEPAGE, 'Spotlight Listings Loaded', cityState)
        dispatch(setIsSpotlightListablesLoading(false))
      }
    } catch (error) {
      if (!isCommonAuthError(error)) {
        logger.error('error while calling loadHomepageSpotlightListings', error)
      }
      dispatch(setIsSpotlightListablesLoading(false))
    }
  }
export default loadHomepageSpotlightListings
